const PRINT_CLEANUP_DELAY_MS = 1000;

export function qrFileName(slug: string): string {
  return `qr-${slug}.png`;
}

/** Base64 sin el prefijo `data:...;base64,` (formato que pide Filesystem.writeFile). */
export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error ?? new Error('No se pudo leer la imagen'));
    reader.onload = () => resolve(String(reader.result).split(',')[1] ?? '');
    reader.readAsDataURL(blob);
  });
}

export function downloadBlob(blob: Blob, fileName: string): void {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}

/** Imprime sólo la imagen: un iframe oculto evita imprimir toda la app con el sheet encima. */
export function printImage(imageUrl: string): void {
  const frame = document.createElement('iframe');
  frame.style.cssText = 'position:fixed;width:0;height:0;border:0;visibility:hidden';
  document.body.appendChild(frame);

  const doc = frame.contentDocument;
  const win = frame.contentWindow;
  if (!doc || !win) {
    document.body.removeChild(frame);
    throw new Error('No se pudo preparar la impresión');
  }

  doc.open();
  doc.write(
    '<!doctype html><html><head><style>' +
    '@page{margin:12mm}body{margin:0;display:grid;place-items:center;min-height:100vh}' +
    'img{max-width:100%;max-height:100vh}</style></head><body><img id="qr"></body></html>'
  );
  doc.close();

  const img = doc.getElementById('qr') as HTMLImageElement;
  img.onload = () => {
    win.focus();
    win.print();
    setTimeout(() => document.body.removeChild(frame), PRINT_CLEANUP_DELAY_MS);
  };
  img.src = imageUrl;
}
